<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>

  <mat-step label="1. Izvještajno razdoblje">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">1. Podaci o izvješću</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (reportInfoFields.length > 0) {
          @for (field of reportInfoFields; track field) {
            <div class="mb-25">
              <p>
                <strong>{{ field.label }}:</strong>
                {{ field.value | date:'d.M.yyyy.' }}
              </p>
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <mat-step label="2. Izravni troškovi">
    @if (directExpenditures.length > 0) {
      @for (item of directExpenditures; track item) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Opis:</strong> {{ item.description }}</p>
              <p><strong>Ugovoreni iznos:</strong> {{ item.contractedFundsAmount | currency:'EUR'  }}</p>
              <p><strong>Realizirani prihvatljivi troškovi:</strong> {{ item.realizedEligibleCosts | currency:'EUR' }}</p>
              @if (expenditureItemFileMap[item.id.toString()] && expenditureItemFileMap[item.id.toString()].length > 0) {
                <p><strong>Dokumentacija:</strong></p>
                <ul>
                  @for (file of expenditureItemFileMap[item.id.toString()]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
      <div class="totals">
        <h4>Ukupno Ugovorenih: {{ totalDirectContractedFunds | currency:'EUR'  }}</h4>
        <h4>Ukupno Realiziranih: {{ totalDirectRealizedCosts | currency:'EUR'  }}</h4>
      </div>
    } @else {
      <p>Nema izravnih troškova.</p>
    }

  </mat-step>

  <mat-step label="3. Neizravni troškovi">
    @if (indirectExpenditures.length > 0) {
      @for (item of indirectExpenditures; track item) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Opis:</strong> {{ item.description }}</p>
              <p><strong>Ugovoreni iznos:</strong> {{ item.contractedFundsAmount | currency:'EUR'  }}</p>
              <p><strong>Realizirani prihvatljivi troškovi:</strong> {{ item.realizedEligibleCosts | currency:'EUR'  }}</p>
              @if (expenditureItemFileMap[item.id.toString()] && expenditureItemFileMap[item.id.toString()].length > 0) {
                <p><strong>Dokumentacija za stavku:</strong></p>
                <ul>
                  @for (file of expenditureItemFileMap[item.id.toString()]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
      <div class="totals">
        <h4>Ukupno Ugovorenih: {{ totalIndirectContractedFunds | currency:'EUR'  }}</h4>
        <h4>Ukupno Realiziranih: {{ totalIndirectRealizedCosts | currency:'EUR'  }}</h4>
      </div>
    } @else {
      <p>Nema neizravnih troškova.</p>
    }

  </mat-step>

  <mat-step label="4. Sveukupni troškovi">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-content>
        <h4>Sveukupno Ugovorenih (A + B): {{ totalAllContracted | currency:'EUR'  }}</h4>
        <h4>Sveukupno Realiziranih (A + B): {{ totalAllRealized | currency:'EUR'  }}</h4>
      </mat-card-content>
    </mat-card>
  </mat-step>


</mat-stepper>